var map = {
	"./projectsJS[it].js": 597,
	"./projectsJS[uk].js": 392,
	"./projectsLaravel[it].js": 80,
	"./projectsLaravel[uk].js": 827,
	"./projectsNode[it].js": 485,
	"./projectsNode[uk].js": 875,
	"./projectsPHP[it].js": 78,
	"./projectsPHP[uk].js": 947,
	"./projectsReact[it].js": 404,
	"./projectsReact[uk].js": 233,
	"./projectsVue[it].js": 194,
	"./projectsVue[uk].js": 683
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 939;